
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  apiFactoryOrderLists,
  apiShopOrderDetail,
  apiShopOrderLog,
} from "@/api/order";
import { apiShopLists,apiShopShopStatistics } from "@/api/shop";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
@Component({
  components: {
    LsPagination,
    DatePicker,
    elImageViewer,
  },
})
export default class OrderList extends Vue {
  // 界面表格数据
  pager: any = new RequestPaging();

  apiFactoryOrderLists = apiFactoryOrderLists;
  searchObj: any = {
    order_sn: "",
    start_time: "",
    end_time: "",
    version: "",
    id: "",
    name: "",
    order_status: "-1",
    remarkcolour: "",
    source: "",
    admin_id: null,
    out_id: "",
    line_id: "",
    finish_sn: "",
    // time_type: 'create_time',
    sku: "",
    code: "",
    copysid_id: "",
    sku_code: "",
    delivery_status: "",
    face_url: "",
    goods_id: "",
    spec_value_str: "",
    images_status: "",
    sku_num: "",
    order_type: "",
    spec: "",
    production_time: "",
    delivery_sn: "",
    tag_name: "",
    order_by_order_sn: "",
    order_by_spec_value_str: "",
    order_by_id: "",
    order_out_label: "",
    is_transfer_order: "",
    settlement_status: 0,
    is_express_price: 0,
    order_remark: "", // 用户备注
    spec_value_str_two: [],
    out_sku_code: "", // 外部sku
    out_spec_value_str: "", // 外部规格
    send_time_start_time: "", // 出库时间
    send_time_end_time: "", // 出库时间
    pay_time_start: "", // 支付时间
    pay_time_end: "", // 支付时间
    out_type: 0, // 出库类型
    system_express_id: "", // 物流商
  };
  time: any = [];
  loading = false;
  selectionArr: any[] = [];

  shop_lists: any[] = [];

  drawerFlag = false;

  orderDetailData: any = {};
  imgList: Array<string> = [];
  imgViewerVisible: boolean = false;
  stepData: any = [];

  // 日期选择器配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  handleSearch() {
    this.getOrderList();
  }
  getYesterdayDate(type = 1) {
    let date = new Date();
    if (type == 1) {
      date.setDate(date.getDate() - 1);
    }
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return `${year}-${month}-${day}`;
  }
  changeDate() {
    if (!this.time) {
      this.searchObj.start_time = "";
      this.searchObj.end_time = "";
    } else {
      this.searchObj.start_time = this.time[0];
      this.searchObj.end_time = this.time[1];
    }
    this.getOrderList();
  }
  // 倒计时
  startFormattedCountdown(timestamp: any, index: number) {
    if (timestamp === null || timestamp === 0 || timestamp === "") {
      this.$set(this.pager.lists[index], "diffTime", "");
      return;
    }
    let currentTime = new Date().getTime();
    let targetTime = Number(timestamp * 1000 + "");
    let diffTime = targetTime - currentTime;
    this.$set(this.pager.lists[index], "diffTime", diffTime);
  }

  showTimeFormatt(diffTime: any, index: any) {
    if (
      diffTime === null ||
      diffTime === 0 ||
      diffTime === "" ||
      diffTime === undefined
    )
      return false;
    let msg = "";
    if (diffTime <= 0) {
      // 已过期
      diffTime = Math.abs(diffTime);
      msg = "已超时:" + ":";
    } else {
      msg = "距离到期:" + ":";
    }
    const totalSeconds = Math.floor(diffTime / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${msg}${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  getShopList() {
    apiShopLists({ page_size: 9999 }).then((res) => {
      this.shop_lists = res.lists;
    });
    apiShopShopStatistics({}).then((res) => {
      console.log(res,'111');
    });
  }

  getOrderList() {
    this.loading = true; // 开始加载状态
    this.pager
      .request({
        callback: this.apiFactoryOrderLists,
        params: {
          ...this.searchObj,
        }, // 传递搜索参数
      })
      .then((res: any) => {
        this.loading = false; // 请求完成，停止加载状态
      })
      .catch((error: any) => {
        console.error("获取订单列表失败:", error);
      });
  }

  showOrderDetail(id: number) {
    // 实现查看详情逻辑
    // console.log("查看订单详情，订单ID:", id);

    apiShopOrderLog({ id: id }).then((res) => {
      res.unshift({
        content: "平台分派单给您，待确认",
        create_time: this.orderDetailData.create_time,
        id: 0,
      });
      this.stepData = res;
    });
    apiShopOrderDetail({ id: id }).then((res) => {
      this.$set(res, "tagData", []);
      this.orderDetailData = res;
      this.drawerFlag = true;
    });
  }

  //查看原图
  lookOriginImage() {
    if (!this.orderDetailData.images.length) {
      return this.$message.error("暂无图片");
    }
    this.imgList = this.orderDetailData.images;
    this.imgViewerVisible = true;
    this.drawerFlag = false;
  }

  //查看工厂图
  lookFactoryImage() {
    let factoryImage = this.orderDetailData.factory_imgs;
    if (!factoryImage.length) {
      return this.$message.error("暂无图片");
    }
    try {
      factoryImage = JSON.parse(factoryImage);
    } catch (err: any) {
      factoryImage = factoryImage;
    }
    this.imgList = factoryImage;
    this.imgViewerVisible = true;
    this.drawerFlag = false;
  }
  setRowClassName(row: any) {
    return "custom-row"; // 原逻辑两个返回值相同，简化
  }

  handleSelectionChange(selectedItems: any[]) {
    this.selectionArr = selectedItems; // 更新选中项数组
  }

  getRowKeys(item: any) {
    return item.id;
  }

  getSpecValue(input: any) {
    return this.processInput(input);
  }

  getLogistics(logistics: any) {
    // return this.setLogistics(logistics);
  }

  getProductionCode(row: any) {
    return row.model_id + this.processInput(row.spec_value_str);
  }

  getMainImage(row: any, size: 150) {
    if (row.image) {
      if (typeof row.image === "string") {
        return `${row.image}?x-oss-process=image/resize,w_${size},h_${size}`;
      } else if (typeof row.image === "object") {
        return `${row.image[0]}?x-oss-process=image/resize,w_${size},h_${size}`;
      }
    }
  }

  getOrderInfo(row: any) {
    const infoList = [];
    if (row.otherdata?.source_name) {
      infoList.push({
        key: "source_name",
        class: "marr-8 primary-color",
        text: row.otherdata.source_name,
      });
    }
    if (row.order_sn) {
      infoList.push({
        key: "order_sn",
        class: "marr-8",
        text: "订单号: " + row.order_sn,
      });
    }
    if (row.out_id) {
      infoList.push({
        key: "out_id",
        class: "marr-8",
        text: "外部订单号: " + row.out_id,
      });
    }
    if (row.plan_code) {
      infoList.push({
        key: "plan_code",
        class: "marr-8",
        text: "生产计划:" + "【" + row.plan_code + "】" + row.plan_name,
      });
    }
    if (row.order_sn_s) {
      infoList.push({
        key: "order_sn_s",
        class: "marr-8",
        text: "子订单号:" + row.order_sn_s,
      });
    }
    if (row.return_order === 1) {
      infoList.push({
        key: "remark",
        class: "return-remark",
        text: row.remark,
      });
    }
    return infoList;
  }

  getOrderTypeText(type: number) {
    switch (type) {
      case 1:
        return "一项一件";
      case 2:
        return "一项多件";
      case 3:
        return "多项多件";
      default:
        return "";
    }
  }

  processInput(input: any) {
    if (!input) return "";
    if (input.includes("},")) {
      try {
        const parseItem = JSON.parse(`[${input}]`);
        const zhCnArr = parseItem.map((v: any) => v.zh_cn);
        return zhCnArr.join(",");
      } catch (e) {
        return input;
      }
    } else if (input.includes("{") && input.includes("}")) {
      try {
        const parseItem = JSON.parse(input);
        return parseItem.zh_cn || parseItem;
      } catch (e) {
        return input;
      }
    } else {
      return input;
    }
  }

  timestampToYYMMDDHHMMSS(timestamp: number) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  checkTimeStatus(inputTime: string | number): string {
    const now = new Date();
    const targetTime = new Date(inputTime);

    if (isNaN(targetTime.getTime())) {
      console.error(
        "Invalid time format, please use YYYY-MM-DD hh:mm:ss or timestamp",
      );
      return "blue"; // 返回默认值
    }

    const diffInMs = targetTime.getTime() - now.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    if (diffInMs < 0) {
      return "red"; // 已过期
    } else if (diffInHours <= 3) {
      return "#ffd704"; // 三小时内 // 橘色
    } else {
      return "blue"; // 其他情况
    }
  }
  mounted() {
    if (this.$route.query.version) {
      this.searchObj.version = this.$route.query.version;
    }
    this.pager.size = 20;
    this.getShopList();
    let start_time = new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    let end_time = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    this.searchObj.start_time = start_time;
    this.searchObj.end_time = end_time;
    this.time = [start_time, end_time];
    this.getOrderList();
  }
}
